<template>
  <div class="page-wrapper">
    <main class="main">
      <div class="page-header">
        <div class="container">
          <h1 class="page-title mb-0">
            {{ $yuyanbao.guanyuwomen }}
          </h1>
        </div>
      </div>

      <nav class="breadcrumb-nav mb-10 pb-8">
        <div class="container">
          <ul class="breadcrumb">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>{{ $yuyanbao.guanyuwomen }}</li>
          </ul>
        </div>
      </nav>
      <div class="page-content">
        <div class="container">
          <section class="introduce mb-10 pb-10">
            <h2 class="title title-center">
              {{ $shezhi.guanyuwomen }}
            </h2>
            <p class="mx-auto text-center">
              {{ $shezhi.guanyuwomen2 }}
            </p>
            <figure class="br-lg">
              <img
                :src="$shezhi.guanyuwomentupian"
                width="1240"
                height="540"
                style="background-color: #d0c1ae"
              />
            </figure>
          </section>

          <section class="customer-service mb-7">
            <div class="row align-items-center">
              <div class="col-md-6 pr-lg-8 mb-8">
                <h2 class="title text-left">
                  {{ $shezhi.guanyuwomen3 }}
                </h2>
                <div class="accordion accordion-simple accordion-plus">
                  <div class="card border-no">
                    <div class="card-header">
                      <a href="#collapse3-1" class="collapse">
                        {{ $shezhi.guanyuwomen4 }}
                      </a>
                    </div>
                    <div class="card-body expanded" id="collapse3-1">
                      <p class="mb-0">
                        {{ $shezhi.guanyuwomen5 }}
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <a href="#collapse3-2" class="expand">
                        {{ $shezhi.guanyuwomen6 }}
                      </a>
                    </div>
                    <div class="card-body collapsed" id="collapse3-2">
                      <p class="mb-0">
                        {{ $shezhi.guanyuwomen7 }}
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <a href="#collapse3-3" class="expand">
                        {{ $shezhi.guanyuwomen8 }}
                      </a>
                    </div>
                    <div class="card-body collapsed" id="collapse3-3">
                      <p class="mb-0">
                        {{ $shezhi.guanyuwomen9 }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-8">
                <figure class="br-lg">
                  <img
                    :src="$shezhi.guanyuwomentupian2"
                    width="610"
                    height="500"
                    style="background-color: #cececc"
                  />
                </figure>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {};
  },
  mounted() {},
};
</script>
